import React from 'react';

export interface ContextProps {
    /**
     * Value context
     */
    value: any;
}

export const Context = React.createContext<ContextProps>({ value: undefined });

const Consumer = (Component: any) => (props: any) => (
    <Context.Consumer>{provider => <Component {...provider} {...props} />}</Context.Consumer>
);

export default {
    Provider: Context.Provider,
    Consumer,
};
